import { render, staticRenderFns } from "./BidDocument.vue?vue&type=template&id=074a3970&scoped=true"
import script from "./BidDocument.vue?vue&type=script&lang=js"
export * from "./BidDocument.vue?vue&type=script&lang=js"
import style0 from "./BidDocument.vue?vue&type=style&index=0&id=074a3970&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074a3970",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('074a3970')) {
      api.createRecord('074a3970', component.options)
    } else {
      api.reload('074a3970', component.options)
    }
    module.hot.accept("./BidDocument.vue?vue&type=template&id=074a3970&scoped=true", function () {
      api.rerender('074a3970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/BidDocument.vue"
export default component.exports